import React, { Component } from 'react'
import { Button, Form, Grid, Header, Image, Message, Segment } from 'semantic-ui-react'
import { observer } from 'mobx-react'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import AuthenticationStore from '../stores/AuthenticationStore'

@withRouter
@observer
class LoginScreen extends Component {
  static propTypes = {
    authenticationStore: PropTypes.instanceOf(AuthenticationStore),
    history: PropTypes.object
  }

  constructor (props) {
    super(props)
    this.state = {
      code: '',
      password: ''
    }
  }

  handleChange (event, data, field) {
    this.setState({ [field]: data.value })
  }

  sendLogin (e) {
    const { code, password } = this.state
    const { authenticationStore } = this.props
    authenticationStore.login(code, password).then((response) => {
      if (response.success && ['PUSH'].includes(this.props.history.action)) {
        this.props.history.goBack()
      }
    })
  }

  render () {
    const { code, password } = this.state
    const { isLoading, errorMessage } = this.props.authenticationStore
    return (
      <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
        <Grid.Column style={{ maxWidth: 450 }}>
          <Image src='/img/mci/mci_logo_new.png' size='large' />
          <Header as='h2' className='primary-blue' textAlign='center'>
            Connexion à votre compte
          </Header>
          <Form size='large' loading={isLoading}>
            {!!errorMessage &&
              <Message negative>
                <p>{errorMessage}</p>
              </Message>}
            <Segment>
              <Form.Input
                fluid
                icon='user'
                iconPosition='left'
                placeholder="Code d'utilisateur"
                value={code}
                onChange={(event, data) => this.handleChange(event, data, 'code')}
              />
              <Form.Input
                fluid
                icon='lock'
                iconPosition='left'
                placeholder='Mot de passe'
                type='password'
                value={password}
                onChange={(event, data) => this.handleChange(event, data, 'password')}
              />

              <Button color='youtube' fluid size='large' onClick={(e) => this.sendLogin(e)}>
                Se connecter
              </Button>
            </Segment>
          </Form>
        </Grid.Column>
      </Grid>
    )
  }
}

export default LoginScreen
